import moment, { Moment } from 'moment-timezone';
import type { WeeklyBreakdownReportDto, CountPercentRowDto } from './WeeklyBreakdownReportDto';
import type { WeeklyBreakdownReport, WeekDayKey, CountPercentRow } from 'model/BookingsWeeklyBreakdownReport';

const DAY_KEYS: WeekDayKey[] = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

// Helper: date-only "YYYY-MM-DD" -> Moment en tz (sin correrse por offset)
const toTzDate = (dateStr: string, timeZone: string): Moment => moment.tz(dateStr, 'YYYY-MM-DD', timeZone);

const convertCountPercentRow = (row: CountPercentRowDto): CountPercentRow => {
    const values = DAY_KEYS.reduce((acc, k) => {
        acc[k] = { value: row[k].value, pct: row[k].pct };
        return acc;
    }, {} as CountPercentRow['values']);

    return {
        values,
        total: row.total
    };
};

export const convertToWeeklyBreakdownReport = (
    dto: WeeklyBreakdownReportDto,
    timeZone: string
): WeeklyBreakdownReport => {
    const days = DAY_KEYS.reduce((acc, k) => {
        acc[k] = toTzDate(dto.days[k], timeZone);
        return acc;
    }, {} as Record<WeekDayKey, Moment>);

    return {
        weekStart: toTzDate(dto.week_start, timeZone),
        weekEnd: toTzDate(dto.week_end, timeZone),
        days,

        totalBookings: dto.total_bookings,
        bookingsPct: dto.bookings_pct,

        completed: convertCountPercentRow(dto.completed),
        canceled: convertCountPercentRow(dto.canceled),
        noShow: convertCountPercentRow(dto.no_show),

        totalPets: dto.total_pets,
        totalClients: dto.total_clients,

        netSales: dto.net_sales,
        salesPct: dto.sales_pct
    };
};
